import script from "./Announcement.vue?vue&type=script&setup=true&lang=js"
export * from "./Announcement.vue?vue&type=script&setup=true&lang=js"

import "./Announcement.vue?vue&type=style&index=0&id=22a9d53b&lang=less&scoped=true"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22a9d53b"]])

export default __exports__